import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'
import { light, dark } from '@/themes';


Vue.use(Vuetify, { components, directives })

const opts = {
  theme: {
    // dark: true,
    options: { customProperties: true },
    themes: {
      light: light,
      dark: dark,
    }
  }
}

new Vuetify(opts)

export default new Vuetify(opts)
